<template>
  <div :class="{ 'h-100': !!loading || response }">
    <base-steps
      v-if="!loading && !response"
      ref="endsteps"
      @finish="checkout"
      @next="updateOrder"
      @prev="updateOrder"
      :clear="clear"
      :hideButtons="true"
    >
      <div>
        <base-card>
          <base-question text="Confirme as ultimas informações" />

          <base-select
            :title="'Endereço de entrega'"
            @change="selectDelivery"
            v-model="deliveryAddress"
            class="w-100"
          >
            <option :value="-1" selected>Retirar na loja fisica</option>
            <option
              :value="`${index}`"
              v-for="(address, index) in addresses"
              :key="index"
            >
              {{ formatAddress(address) }}
            </option>
          </base-select>

          <base-textarea
            v-model="order.observation"
            label="Observações do pedido"
            rows="5"
            design="four"
          />

          <div class="d-flex mt_20">
            <base-button
              @click="otherValues('addition')"
              :text="!addition ? 'Acréscimo' : 'Remover Acréscimo'"
              class="w-100 mr_10"
              design="four"
            />
            <base-button
              @click="otherValues('discount')"
              :text="!discount ? 'Desconto' : 'Remover Desconto'"
              class="w-100 ml_10"
              design="four"
            />
          </div>
        </base-card>

        <base-card v-if="addition || discount">
          <base-question
            :text="`${
              addition ? 'Qual será o acréscimo?' : 'Qual será o desconto?'
            }`"
          />
          <base-select
            @change="addGift"
            v-model="gift.type"
            :title="`${addition ? 'Tipo do acréscimo' : 'Tipo do desconto'}`"
          >
            <option :value="0">R$</option>
            <option :value="1">%</option>
          </base-select>

          <base-input
            v-show="gift.type == 1"
            id="giftValueField"
            @change="addGift"
            v-model="gift.value"
            :money-mask="StringLanguage.percentConfigs"
            :label="`${addition ? 'Acréscimo' : 'Desconto'}`"
            class="mb_5"
          />
          <base-input
            v-show="gift.type == 0"
            id="giftPercentField"
            @change="addGift"
            v-model="gift.value"
            :money-mask="StringLanguage.currencyConfigs"
            :label="`${addition ? 'Acréscimo' : 'Desconto'}`"
            class="mb_5"
          />
        </base-card>

        <base-card>
          <order-prices
            :discount="parseFloat(discountValue)"
            :addition="parseFloat(additionValue)"
            :total="order.cart && order.cart.total ? order.cart.total : 0"
            :freeFee="freeFee"
            :outOfRegion="outOfRegion"
            :delivery="
              order.delivery && order.delivery.total ? order.delivery.total : 0
            "
          />
        </base-card>
      </div>

      <div v-if="firstPayment.length > 0">
        <base-card
          class="relative"
          v-for="(payer, index) in order.payment.payers"
          :key="index"
        >
          <sales-payer
            :paymentTabs="paymentTabs"
            :tabIndex="tabIndex[index]"
            :index="index"
            :payer="payer"
            :multiplePayers="index > 0 ? true : false"
            @removePayer="removePayer"
            @setPayerMethod="setPayerMethod"
            @setChangeFor="setChangeFor"
          />
        </base-card>

        <base-card>
          <base-add
            text="Adicionar pagante"
            design="two"
            height="120px"
            class="mb_20"
            @click.native="addPayer(true)"
          />
        </base-card>
      </div>

      <div v-else>
        <base-card class="relative">
          <base-message>
            Você não tem nenhuma forma de pagamento cadastrada.
          </base-message>

          <div class="mt_15 text-center">
            <router-link :to="{ name: 'pagamento' }" class="go-payment">
              Cadastre agora mesmo
            </router-link>
          </div>
        </base-card>
      </div>
    </base-steps>

    <base-card
      v-if="!!loading && !response"
      class="d-flex align-center justify-center h-100"
    >
      <base-loading color="var(--default)" />
    </base-card>

    <base-card
      v-show="response === 'success'"
      class="d-flex align-center justify-center h-100"
    >
      <div class="d-flex justify-center flex-column align-center">
        <img src="@/assets/img/success.svg" alt="Sucesso" />
        <p class="statusOrder">Pedido efetuado com sucesso!</p>
      </div>
    </base-card>
    <base-card
      v-show="response === 'error'"
      class="d-flex align-center justify-center h-100"
    >
      <div class="d-flex justify-center flex-column align-center">
        <img src="@/assets/img/error.svg" alt="Erro" />
        <p class="statusOrder">Ocorreu um erro no processo.</p>
      </div>
    </base-card>
  </div>
</template>
<script>
import { PaymentMethod, Method, Status } from 'easyjs/lib/Schema/Payment';
import { OrderOrigin } from 'easyjs/lib/Schema/Order';
import { DeliveryType } from 'easyjs/lib/Schema/Delivery';
import { TYPE } from 'easyjs/lib/Schema/Gift';
import Geolocation from 'easyjs/lib/Schema/Address/Geolocation';
import BaseSteps from '@/components/Steps';
import BaseCard from '@/components/Card';
import BaseQuestion from '@/components/Question';
import BaseRadio from '@/components/Radio';
import BaseButton from '@/components/Button';
import BaseTabs from '@/components/Tabs';
import BaseAdd from '@/components/Add';
import BaseInput from '@/components/Input';
import BaseTextarea from '@/components/Textarea';
import BaseSelect from '@/components/Select';
import BaseMessage from '@/components/Message';
import BaseLoading from '@/components/Loading';

import OrderPrices from '@/containers/Orders/OrderPrices';
import OrderApi from '@/api/order';
import StoreAPI from '@/api/store';
import store from '@/store';

import Utils from '@/utils';
import SalesPayer from './SalesPayer';

export default {
  props: {
    order: {},
    customer: {},
    payments: {},
    configurations: {},
    selectedDeliveryAddress: {},
  },
  mounted() {
    this.deliveryAddress = this.selectedDeliveryAddress;
    this.formatPayments();
    this.selectDelivery();
    this.setInitialGift();
  },
  data() {
    return {
      Utils,
      clear: false,
      loading: false,
      response: null,
      // total: 0,
      equalDivision: true,
      tabActive: 0,
      finished: false,
      freeFee: false,
      outOfRegion: false,
      paymentTabs: [
        {
          name: 'Crédito',
          value: 'credit',
          type: PaymentMethod.CREDIT | PaymentMethod.FISICO,
          enabled: false,
          methods: [],
        },
        {
          name: 'Débito',
          value: 'debit',
          type: PaymentMethod.DEBIT | PaymentMethod.FISICO,
          enabled: false,
          methods: [],
        },
        {
          name: 'Voucher',
          value: 'voucher',
          type: PaymentMethod.VOUCHER | PaymentMethod.FISICO,
          enabled: false,
          methods: [],
        },
        {
          name: 'Dinheiro',
          value: 'others',
          type: PaymentMethod.MONEY | PaymentMethod.FISICO,
          enabled: false,
          methods: [],
        },
      ],
      deliveryAddress: -1,
      tabIndex: [],
      addition: false,
      discount: false,
      gift: {
        type: 0,
        value: 0,
      },
      discountValue: 0,
      additionValue: 0,
      checkoutValidateMsgError: '',
    };
  },
  methods: {
    updateOrder() {
      this.recalculePayer();
    },
    setInitialGift() {
      if (this.order.gift) {
        this.gift.type =
          this.order.gift.type === 138 || this.order.gift.type === 139 ? 0 : 1;
        this.gift.value = parseFloat(this.order.gift.value || 0).toFixed(2);
        this.discount =
          this.order.gift.type === 138 || this.order.gift.type === 140;
        this.addition =
          this.order.gift.type === 139 || this.order.gift.type === 141;
      }
    },
    formatAddress(address) {
      return `${address.address}${
        address.number !== 'null' || address.complement ? ',' : ''
      } ${address.number !== 'null' ? address.number : ''} ${
        address.complement ? `(${address.complement})` : ''
      } - ${address.region}, ${address.city}, ${this.getUfFromState(
        address.state
      )}`;
    },
    getUfFromState(state) {
      const states = {
        Acre: 'AC',
        Alagoas: 'AL',
        Amapá: 'AP',
        Amazonas: 'AM',
        Bahia: 'BA',
        Ceará: 'CE',
        'Distrito Federal': 'DF',
        'Espírito Santo': 'ES',
        Goiás: 'GO',
        Maranhão: 'MA',
        'Mato Grosso': 'MT',
        'Mato Grosso do Sul': 'MS',
        'Minas Gerais': 'MG',
        Pará: 'PA',
        Paraíba: 'PB',
        Paraná: 'PR',
        Pernambuco: 'PE',
        Piauí: 'PI',
        Roraima: 'RR',
        Rondônia: 'RO',
        'Rio de Janeiro': 'RJ',
        'Rio Grande do Norte': 'RN',
        'Rio Grande do Sul': 'RS',
        'Santa Catarina': 'SC',
        'São Paulo': 'SP',
        Sergipe: 'SE',
        Tocantins: 'TO',
      };

      return states[state];
    },
    addPayer() {
      const customer = JSON.parse(JSON.stringify(this.customer));
      delete customer.birthdate;
      delete customer.status;
      delete customer.is_client;
      delete customer.addresses;

      if (this.firstPayment.length > 0) {
        this.order.payment.payers.push({
          amount: 0,
          paymentMethod: this.firstPayment[0].type,
          method: this.firstPayment[0].methods[0].alias,
          changeFor: null,
          status: 2,
          user: customer,
          hasChange: false,
        });

        this.tabIndex.push(0);
        this.recalculePayer();
      }
    },
    removePayer(index) {
      this.order.payment.payers.splice(index, 1);
      this.tabIndex.splice(index, 1);
      this.recalculePayer();
    },
    recalculePayer(index = false) {
      let newTotal = this.total;

      if (this.order.gift && this.order.gift.value) {
        newTotal = this.addition
          ? parseFloat(this.total) + parseFloat(this.additionValue)
          : parseFloat(this.total) - parseFloat(this.discountValue);
      }

      if (this.equalDivision) {
        const countPayers = this.order.payment.payers.length;
        for (const payer of this.order.payment.payers) {
          payer.amount = (newTotal / countPayers).toFixed(2);
        }
      } else {
        this.order.payment.payers.forEach((e, i, a) => {
          if (!index && i == 0) {
            e.amount = newTotal;
          }
        });
      }

      this.order.total = newTotal;
    },
    setPayerMethod(index, item, tabActive) {
      this.order.payment.payers[index].paymentMethod = item.type;
      this.tabActive = tabActive;
    },
    selectDelivery() {
      this.order.delivery.address = null;
      this.order.delivery.total = 0;

      const { delivery_time } = this.$props.configurations || {
        minDesk: '',
        maxDesk: '',
      };
      const { minDesk, maxDesk } = delivery_time;
      this.order.delivery.deliveryStrip = {
        minDesk,
        maxDesk,
      };
      if (this.deliveryAddress >= 0) {
        this.order.delivery.type = 1;
        this.order.delivery.address =
          this.customer.addresses[this.deliveryAddress];
        this.order.delivery.address.zipcode = `${this.order.delivery.address.zipcode}`;
        const { deliveryTax, radiusStrip } = this.deliveryTax(
          this.customer.addresses[this.deliveryAddress].geolocation
        );

        // Se não foi encontrada região de entrega
        if (radiusStrip === null) {
          this.outOfRegion = true;
          this.freeFee = false;
        } else {
          this.freeFee = !!radiusStrip.free_fee;
          this.outOfRegion = false;
          this.order.delivery.total = +deliveryTax;
          this.order.delivery.deliveryStrip = radiusStrip;
        }
      } else {
        this.outOfRegion = false;
        this.order.delivery.type = 2;
      }

      this.$emit('addressChanged', this.deliveryAddress);
    },
    formatPayments() {
      if (this.payments && this.payments.length > 0) {
        // Ordenação dos métodos de pagamento por importância
        this.payments.sort((paymentA, paymentB) => {
          if (
            Method[paymentA.alias].importance >
            Method[paymentB.alias].importance
          )
            return -1;
          if (
            Method[paymentA.alias].importance <
            Method[paymentB.alias].importance
          )
            return 1;
          return paymentA.alias.localeCompare(paymentB.alias);
        });

        this.paymentTabs.forEach((tab) => {
          tab.methods = [];
          this.payments.forEach((payment) => {
            if ((tab.type & payment.type) >= tab.type && payment.active) {
              tab.methods.push(payment);
            }
          });
          tab.enabled = tab.methods.length > 0;
        });
      }

      if (this.order.payment.payers.length == 0) {
        this.order.payment.payers = [];
        this.addPayer();
      } else {
        this.order.payment.payers.forEach((p, pIndex) => {
          // Buscar a aba relacionada ao pedido
          this.paymentTabs.forEach((pT, i) => {
            if (pT.type == p.paymentMethod) {
              this.tabIndex[pIndex] = i;
            }
          });

          if (p.paymentMethod == (PaymentMethod.MONEY | PaymentMethod.FISICO)) {
            p.hasChange = true;
            p.changeFor = null;
          }
        });
      }

      this.$forceUpdate();
    },
    addGift() {
      const type = this.addition
        ? TYPE.ADDITION |
          TYPE.FREE_TO_USE |
          (this.gift.type == 0 ? TYPE.PRICE : TYPE.PERCENT) |
          TYPE.CART
        : TYPE.FREE_TO_USE |
          (this.gift.type == 0 ? TYPE.PRICE : TYPE.PERCENT) |
          TYPE.CART;
      if (this.discount) {
        if (+this.gift.value < 0) {
          this.gift.value = '0.00';
        } else if (this.gift.type == 1 && +this.gift.value > 100) {
          // Se o desconto for do tipo porcentagem e o valor informado for maior que 100%
          this.gift.value = '100.00';
        } else if (
          this.gift.type == 0 &&
          +this.gift.value > this.order.cart.total
        ) {
          // Se o desconto for do tipo valor e o valor informado for maior que o total do carrinho
          this.gift.value = this.order.cart.total.toFixed(2);
        }
      }

      if (this.addition) {
        if (+this.gift.value < 0) {
          this.gift.value = '0.00';
        } else if (this.gift.type == 1 && +this.gift.value > 999) {
          // Se o desconto for do tipo porcentagem e o valor informado for maior que 100%
          this.gift.value = '999.99';
        } else if (this.gift.type == 0 && +this.gift.value > 9999.99) {
          // Se o desconto for do tipo valor e o valor informado for maior que o total do carrinho
          this.gift.value = '9999.99';
        }
      }

      this.order.gift = {
        type,
        value: parseFloat(this.gift.value),
      };

      this.discountValue = this.discount
        ? this.gift.type == 0
          ? this.gift.value
          : this.order.cart.total * (this.gift.value / 100)
        : 0;
      this.additionValue = this.addition
        ? this.gift.type == 0
          ? this.gift.value
          : this.order.cart.total * (this.gift.value / 100)
        : 0;
    },
    checkMaxChangeFor(payer) {
      // let maxChangeFor = (Math.floor((+payer.amount)/100) + 1) * 100;
      // if((+payer.changeFor) > maxChangeFor) {
      //     payer.changeFor = maxChangeFor.toFixed(2);
      // }
    },
    checkMinChangeFor(payer) {
      if (+payer.changeFor < +payer.amount) {
        payer.changeFor = (+payer.amount).toFixed(2);
      }
    },
    cleanChangeFor(payer) {
      payer.changeFor = payer.amount;
    },
    setChangeFor(index, changeFor, hasChange) {
      this.order.payment.payers[index].hasChange = hasChange;
      this.order.payment.payers[index].changeFor = changeFor;
    },
    validateCheckout() {
      let validated = true;
      const order = JSON.parse(JSON.stringify({ ...this.order }));

      // Essa função foi adicionada para resolver temporáriamente o problema
      // relacionado a quantidade dos itens do carrinho pois quando é realizado
      // o JSON.stringfy() a quantidade de todos os itens são resetadas para 1
      this.order.cart.catalog.items.forEach((item, index) => {
        order.cart.catalog.items[index].quantity = item.quantity;
      });

      const customer = JSON.parse(JSON.stringify(this.customer));
      delete customer.annotation;
      delete customer.addresses;

      order.origin =
        order.delivery.type === DeliveryType.DELIVER_ON_ADDRESS
          ? OrderOrigin.PHONE
          : OrderOrigin.DESK;

      delete order.subtotal;
      delete order.created_at;
      delete order.created_by;
      delete order.order_id;
      delete order.status;
      delete order.position;
      delete order.cashback;

      delete customer.birthdate;
      delete customer.status;
      delete customer.is_client;
      delete customer.addresses;
      delete customer.lgpd;

      order.payment.total = 0;

      let orderTotalRest = order.total;
      const payersLength = order.payment.payers.length;
      const totalByPayer = parseFloat(orderTotalRest / payersLength).toFixed(2);

      order.payment.payers.forEach((payer, i) => {
        const amountByPayer = parseFloat(
          orderTotalRest > totalByPayer ? totalByPayer : orderTotalRest
        );

        payer.amount = amountByPayer;
        orderTotalRest -= amountByPayer;
        order.payment.total += amountByPayer;

        payer.changeFor = payer.changeFor ? parseFloat(payer.changeFor) : 0;

        delete payer.id;
        delete payer.user;

        if (
          payer.paymentMethod !=
          (PaymentMethod.MONEY | PaymentMethod.FISICO)
        ) {
          payer.changeFor = 0;
        } else {
          // Somente valida dinheiro quando a forma de pagamento for dinheiro
          const { hasChange } = payer;
          if ((hasChange && +payer.changeFor > +payer.amount) || !hasChange) {
            validated = true;
          } else {
            validated = false;
            this.checkoutValidateMsgError =
              'O valor para troco deve ser maior que o valor do pedido.';
          }
        }

        delete payer.hasChange;
      });

      if (order.total.toFixed(2) !== order.payment.total.toFixed(2)) {
        validated = false;
        this.checkoutValidateMsgError =
          'O valor total dos pagantes é diferente do valor total';
      }

      if (!Utils.empty(customer)) {
        order.payment.payers.forEach((payer) => {
          payer.user = customer;
        });
      }

      if (validated) {
        return order;
      }

      return false;
    },
    checkout() {
      if (this.firstPayment.length == 0) {
        this.$emit('disabledNextButton');
        return;
      }

      const isCheckoutValid = this.validateCheckout();

      if (!isCheckoutValid) {
        alert(this.checkoutValidateMsgError);
        return false;
      }
      store.commit('store/setHasPendingOrders', true);

      this.$emit('finish', isCheckoutValid);
    },

    otherValues(operation) {
      this[operation] = !this[operation];

      if (operation === 'addition') {
        this.discount = '';
      } else {
        this.addition = '';
      }

      this.gift.value = 0;
      this.gift.type = 0;
    },

    prevStepFinish() {
      this.$refs.endsteps.prev();
    },

    nextStepFinish() {
      if (this.outOfRegion) {
        alert('O endereço selecionado está fora da região de entrega!');
      } else {
        this.$refs.endsteps.next();
      }
    },
    showLoading(status) {
      if (status === true) {
        this.loading = !this.loading;
      } else {
        this.loading = false;
      }
    },
    showResponse(status) {
      this.loading = false;
      switch (status) {
        case 'success':
          StoreAPI.storeConfiguration({ hasFirstOrder: true });
          this.response = 'success';
          break;
        case 'error':
          this.response = 'error';
          break;
        case false:
          this.response = null;
          break;
      }

      if (this.order.payment.payers.length == 0) {
        this.order.payment.payers = [];
        this.addPayer();
      }
    },
    deliveryTax(addressGeolocation) {
      if (!addressGeolocation) {
        return false;
      }
      const restaurantGeo = Geolocation.fromObject(
        this.$props.configurations.location.geolocation
      );
      const samePlace =
        restaurantGeo.latitude == addressGeolocation.latitude &&
        restaurantGeo.longitude == addressGeolocation.longitude;
      const distance = samePlace
        ? 0
        : restaurantGeo.distanceTo(addressGeolocation) / 1000;

      const deliveryRegions = this.$props.configurations.delivery_region;
      const radiusStrips = deliveryRegions.filter(
        (region) => +region.up_to >= +distance
      );

      radiusStrips.sort((a, b) => +a.up_to <= +b.up_to);

      if (radiusStrips[0]) {
        return {
          deliveryTax: radiusStrips[0].free_fee ? 0 : radiusStrips[0].price,
          radiusStrip: radiusStrips[0],
        };
      }

      return {
        deliverTax: false,
        radiusStrip: null,
      };
    },
  },
  computed: {
    multiplePayers() {
      let multiplePayers = false;
      if (this.order.payment.payers.length > 1) {
        multiplePayers = true;
      }

      return multiplePayers;
    },
    total() {
      const totalItens =
        this.order && this.order.cart && this.order.cart.total
          ? this.order.cart.total
          : 0;
      const totalDelivery =
        this.order && this.order.delivery && this.order.delivery.total
          ? this.order.delivery.total
          : 0;

      return parseFloat((totalItens + totalDelivery).toFixed(2));
    },
    addresses() {
      if (this.customer && this.customer.addresses) {
        return this.customer.addresses;
      }

      return [];
    },
    firstPayment() {
      return this.paymentTabs.filter(
        (item) => item.methods && item.methods.length > 0 && item
      );
    },
  },
  watch: {
    addition() {
      this.order.gift =
        !this.addition && !this.discount ? null : this.order.gift;
      this.additionValue = !this.addition ? 0 : this.additionValue;
    },
    discount() {
      this.order.gift =
        !this.addition && !this.discount ? null : this.order.gift;
      this.discountValue = !this.discount ? 0 : this.discountValue;
    },
    selectedDeliveryAddress() {
      this.deliveryAddress = this.selectedDeliveryAddress;
    },
  },
  components: {
    BaseSteps,
    BaseCard,
    BaseQuestion,
    BaseRadio,
    BaseButton,
    BaseTabs,
    BaseAdd,
    BaseInput,
    BaseTextarea,
    BaseSelect,
    OrderPrices,
    SalesPayer,
    BaseMessage,
    BaseLoading,
  },
};
</script>
<style scoped>
.payment-tabs {
  margin-bottom: 30px;
}
.delete-payer {
  position: absolute;
  top: 22px;
  right: 17px;
  font-size: 1.4em;
  color: #999;
}
.question-payer {
  margin-bottom: 20px;
}

.go-payment {
  margin-top: 20px;
  color: var(--default);
  font-weight: 300;
  margin-top: 5px;
  text-decoration: underline;
  font-size: 1.3em;
}
.statusOrder {
  color: #aaaaab;
  font-size: 18px;
  margin-top: 20px;
  font-weight: 300;
}

@media screen and (max-width: 991px) {
  .statusOrder {
    font-size: 14px;
  }
}
</style>
